import React, { Suspense, Fragment, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import AdminLayout from './layouts/AdminLayout';

import { BASE_URL } from './config/constant';
import CustomSpinner from './components/Widgets/Loader/CustomSpinner';
import ProtectedRoute from './ProtectedRoute';
import { getSessionStorage } from './utils/helpers';
import { lazyWithAssessmentProtection } from './utils/lazyWithAssessmentProtection';
export const renderRoutes = (routes = []) => (
  <Suspense fallback={<CustomSpinner />}>
    <Routes>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Element = route.element;

        return (
          <Route
            key={i}
            path={route.path}
            element={
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Element props={true} />}</Layout>
              </Guard>
            }
          />
        );
      })}
    </Routes>
  </Suspense>
);
const userType  = getSessionStorage("USER_TYPE");
const routes = [
  {
    path: '*',
    layout: AdminLayout,
    guard: ProtectedRoute,
    routes: [
      {
        exact: 'true',
        path: '/',
        element: lazy(() => import('./views/dashboard'))
      },
      {
        exact: 'true',
        path: '/dashboard',
        element: lazy(() => import('./views/dashboard'))
      },
      {
        exact: 'true',
        path: '/app/dashboard/default',
        element: lazy(() => import('./views/dashboard'))
      },
      {
        exact: 'true',
        path: '/Admin',
        element: lazy(() => import('./views/Admin/ManageEmployee/ManageEmployee'))
      },
      {
        exact: 'true',
        path: '/Admin/ManageEmployee',
        element: lazy(() => import('./views/Admin/ManageEmployee/ManageEmployee'))
      },
      {
        exact: 'true',
        path: '/Admin/ManageAssessor',
        element: lazy(() => import('./views/Admin/ManageAssessor/ManageAssessor'))
      },
      {
        exact: 'true',
        path: '/Admin/ManageSkill',
        element: lazy(() => import('./views/Admin/ManageSkill/ManageSkill'))
      },
      {
        exact: 'true',
        path: '/Admin/ManageExternalUser',
        element: lazy(() => import('./views/Admin/ManageExternalUser/ManageExternalUser'))
      },
      {
        exact: 'true',
        path: '/Admin/ManageEmail',
        element: lazy(() => import('./views/Admin/ManageEmail/ManageEmail'))
      },
      {
        exact: 'true',
        path: '/Admin/ManageEmployeeCycle',
        element: lazy(() => import('./views/Admin/ManageEmployeeCycle/ManageEmployeeCycle'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessment/TechnicalAssessments',
        element: lazy(() => import('./views/TechnicalAssessments/TechnicalAssessments'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessment',
        element: lazy(() => import('./views/TechnicalAssessments/TechnicalAssessments'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessment/TechnicalQuestionBank',
        element: lazy(() => import('./views/TechnicalAssessments/TechnicalQuestionBank'))
      },

      {
        exact: 'true',
        path: '/TechnicalAssessment/ApproveReviewModifications',
        element: lazy(() => import('./views/TechnicalAssessments/ApproveReviewModifications/ApproveReviewModifications'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessment/ApproveReviewModifications/:id',
        element: lazy(() => import('./views/TechnicalAssessments/ApproveReviewModifications/ApproveReviewModifications'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessment/ManageSmeMappings',
        element: lazy(() => import('./views/TechnicalAssessments/ManageSmeMappings/ManageSmeMappings'))
      },
      {
        exact: 'true',
        path: '/AssessmentCycle/AssessmentCycle',
        element: lazy(() => import('./views/AssessmentCycle/AssessmentCycle/AssessmentCycle'))
      },
      {
        exact: 'true',
        path: '/AssessmentCycle',
        element: lazy(() => import('./views/AssessmentCycle/AssessmentCycle/AssessmentCycle'))
      },
      {
        exact: 'true',
        path: '/AssessmentCycle/AssessmentCycle',
        element: lazy(() => import('./views/AssessmentCycle/AssessmentCycle/AssessmentCycle'))
      },
      {
        exact: 'true',
        path: '/AssessmentCycle/QuestionBank',
        element: lazy(() => import('./views/AssessmentCycle/QuestionBank/QuestionBank'))
      },
      {
        exact: 'true',
        path: '/AssessmentCycle/AssessorEmployeeMapping',
        element: lazy(() => import('./views/AssessmentCycle/AssessorEmployeeMapping/AssessorEmployeeMapping'))
      },

      {
        exact: 'true',
        path: '/basic/button',
        element: lazy(() => import('./views/ui-elements/basic/BasicButton'))
      },
      {
        exact: 'true',
        path: '/basic/badges',
        element: lazy(() => import('./views/ui-elements/basic/BasicBadges'))
      },
      {
        exact: 'true',
        path: '/basic/breadcrumb',
        element: lazy(() => import('./views/ui-elements/basic/BasicBreadcrumb'))
      },
      {
        exact: 'true',
        path: '/basic/pagination',
        element: lazy(() => import('./views/ui-elements/basic/BasicPagination'))
      },
      {
        exact: 'true',
        path: '/basic/collapse',
        element: lazy(() => import('./views/ui-elements/basic/BasicCollapse'))
      },
      {
        exact: 'true',
        path: '/basic/tabs-pills',
        element: lazy(() => import('./views/ui-elements/basic/BasicTabsPills'))
      },
      {
        exact: 'true',
        path: '/basic/typography',
        element: lazy(() => import('./views/ui-elements/basic/BasicTypography'))
      },
      {
        exact: 'true',
        path: '/forms/form-basic',
        element: lazy(() => import('./views/forms/FormsElements'))
      },
      {
        exact: 'true',
        path: '/tables/bootstrap',
        element: lazy(() => import('./views/tables/BootstrapTable'))
      },
      {
        exact: 'true',
        path: '/charts/nvd3',
        element: lazy(() => import('./views/charts/nvd3-chart'))
      },
      {
        exact: 'true',
        path: '/maps/google-map',
        element: lazy(() => import('./views/maps/GoogleMaps'))
      },
      {
        exact: 'true',
        path: '/sample-page',
        element: lazy(() => import('./views/extra/SamplePage'))
      },
      {
        path: '*',
        exact: 'true',
        element: () => <Navigate to={BASE_URL} />
      },
      {
        exact: 'true',
        path: '/EmployeesTask',
        element: lazy(() => import('./views/EmployeeTasks/MyEvaluationForm'))
      },
      {
        exact: 'true',
        path: '/EmployeesTask/AssessmentCycle',
        element: lazy(() => import('./views/EmployeeTasks/MyEvaluationForm'))
      },
      {
        exact: 'true',
        path: '/EmployeesTask/AssessmentCycle/MyEvaluationForm',
       // element:userType==='Internal'?lazy(() => import('./views/EmployeeTasks/MyEvaluationInternalFullContent')): lazy(() => import('./views/EmployeeTasks/MyEvaluationFullContent'))
        element:userType==='External'?lazy(() => import('./views/EmployeeTasks/MyEvaluationFullContent')):lazy(() => import('./views/EmployeeTasks/MyEvaluationInternalFullContent'))
      },
      {
        exact: 'true',
        path: '/EmployeesTask/SelfAssessments',
        //element: userType==='Internal'?lazy(() => import('./views/EmployeeTasks/SelfAssessmentInternal')):lazy(() => import('./views/EmployeeTasks/selfAssessment'))
        element: userType==='External'?lazy(() => import('./views/EmployeeTasks/SelfAssessments')):lazy(() => import('./views/EmployeeTasks/SelfAssessmentInternal'))
      },
      {
        exact: 'true',
        path: '/EmployeesTask/QuestionBankReview',
        element: lazy(() => import('./views/EmployeeTasks/QuestionBankReview'))
      },
      {
        exact: 'true',
        path: '/EmployeesTask/QuestionBankReview/:id',
        element: lazy(() => import('./views/EmployeeTasks/QuestionBankReview'))
      },
      {
        exact: 'true',
        path: '/report',
        element: lazy(() => import('./views/Reports/ExternalCandidateReport'))
      },
      {
        exact: 'true',
        path: '/report/CycleComparisonReport',
        element: lazy(() => import('./views/Reports/CycleComparisonReport'))
      },
      {
        exact: 'true',
        path: '/report/ExternalCandidateReport',
        element: lazy(() => import('./views/Reports/ExternalCandidateReport'))
      },
      {
        exact: 'true',
        path: '/AssessmentCycleReport',
        element: lazy(() => import('./views/Reports/AssessmentCycleReport'))
      },
      {
        exact: 'true',
        path: '/report/AssessmentCycleReport',
        element: lazy(() => import('./views/Reports/AssessmentCycleReport'))
      },
      {
        exact: 'true',
        path: '/report/AssessmentCycleReport/UserReport',
        element: lazy(() => import('./views/Reports/AssessmentEmployeeReport'))
      },
      {
        exact: 'true',
        path: '/report/AssessmentCycleReport/CycleDetailReport',
        element: lazy(() => import('./views/Reports/AssessmentDetailReport'))
      },
      {
        exact: 'true',
        path: '/report/AssessmentCycleReport/ActionReport',
        element: lazy(() => import('./views/Reports/AssessmentCycleActionReport'))
      },

      {
        exact: 'true',
        path: '/report/SelfAssessmentReport',
        element: lazy(() => import('./views/Reports/SelfAssessmentReport'))
      },

      {
        exact: 'true',
        path: '/Assessor',
        element: lazy(() => import('./views/Assessor/EvaluateEmployee'))
      },

      {
        exact: 'true',
        path: '/Assessor/UserAnalysis/UsersList',
        element: lazy(() => import('./views/Assessor/EvaluateEmployee'))
      },

      {
        exact: 'true',
        path: '/Assessor/UserAnalysis/CycleList',
        element: lazy(() => import('./views/Assessor/EvaluateEmployee/AssessmentCycles'))
      },

      {
        exact: 'true',
        path: '/UserAnalysis',
        element: lazy(() => import('./views/Assessor/EvaluateEmployee/EvaluationForm'))
      },
      {
        exact: 'true',
        path: '/analytics',
        element: lazy(() => import('./views/Analytics/ReportOne/ReportOne'))
      },
      {
        exact: 'true',
        path: '/analytics/ReportOne',
        element: lazy(() => import('./views/Analytics/ReportOne/ReportOne'))
      },
      {
        exact: 'true',
        path: '/analytics/AssessmentCycleReport',
        element: lazy(() => import('./views/Analytics/ReportOne/AssessmentCycleReport'))
      },
      {
        exact: 'true',
        path: '/reports/SelfAssessmentReport',
        element: lazy(() => import('./views/User/Reports/SelfAssessmentReport'))
      },
      {
        exact: 'true',
        path: '/reports/ExternalCandidateReport',
        element: lazy(() => import('./views/User/Reports/SelfAssessmentReport'))
      },
      {
        exact: 'true',
        path: '/reports',
        element: lazy(() => import('./views/Reports/ExternalCandidateReport'))
      },
      {
        exact: 'true',
        path: '/Dashboard/SkillChangeReview/:id',
        element: lazy(() => import('./views/SkillChangeReview/SkillChangeReview'))
      },
      {
        exact: 'true',
        path: '/Dashboard/SkillChangeReview',
        element: lazy(() => import('./views/SkillChangeReview/SkillChangeReview'))
      },
      {
        exact: 'true',
        path: '/Dashboard/UserProfile',
        element: lazy(() => import('./views/myprofile/MyProfile'))
      },
      {
        exact: 'true',
        path: '/Dashboard/ExternalUserProfile',
        element: lazy(() => import('./views/UserProfile/UserProfile'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessments/ImportQuestionBank',
        element: lazy(() => import('./views/TechnicalAssessments/ImportQuestionBank'))
      },
      {
        exact: 'true',
        path: '/TechnicalAssessments/TakeAssessment',
        element:
          userType === 'External'
            ? lazyWithAssessmentProtection(() =>
                import('./views/EmployeeTasks/take-assessment/TakeAssessment')
              )
            : lazyWithAssessmentProtection(() =>
                import('./views/EmployeeTasks/take-assessment/TakeInternalAssessment')
              )
      },

      {
        exact: 'true',
        path: '/UserProfile',
        element: lazy(() => import('./views/UserProfile/UserProfile'))
      },

      {
        exact: 'true',
        path: '/Assessments',
        element: lazy(() => import('./views/AssessmentLanding/AssessmentLanding'))
       // element:userType==='External'?lazy(() => import('./views/AssessmentLanding/AssessmentLanding')):lazy(() => import('./views/EmployeeTasks/MyEvaluationInternalFullContent'))
      },

      {
        exact: 'true',
        path: '/Assessments/TakeAssessment',
        element: lazyWithAssessmentProtection(() =>
          import('./views/EmployeeTasks/take-assessment/TakeAssessment')
        )
      },

      {
        exact: 'true',
        path: '/Assessments/Assessment',
        element: lazyWithAssessmentProtection(() => import('./views/EmployeeTasks/Assessment'))
      },

      {
        exact: 'true',
        path: '/Assessments/instructions',
        element: lazy(() => import('./views/Instructions/Instructions'))
      },

      {
        exact: 'true',
        path: '/Assessments/UserPrerequisites',
        element: lazy(() => import('./views/ChecksBeforeExamStart/Checks'))
      },
      {
        exact: 'true',
        path: '/Assessments/PostAssessmentFeedback',
        element: lazy(() => import('./views/EmployeeTasks/PostAssessmentFeedback/PostAssessmentFeedback'))
      },
      {
        exact: 'true',
        path: '/permissionform',
        element: lazy(() => import('./views/myprofile/PermissionForm'))
      }
    ]
  }
];

export default routes;
